import { CLEANING_TASK_TYPE, IconName, RESTOCKING_TASK_TYPE, TOUCH_UP_TASK_TYPE } from 'shared';

export const TASK_TYPE_TO_ICON: Record<string, IconName> = {
  [CLEANING_TASK_TYPE]: 'cleaningDeep',
  [TOUCH_UP_TASK_TYPE]: 'cleaningLight',
  [RESTOCKING_TASK_TYPE]: 'snack'
};
